module.exports = __webpack_public_path__ + "static/media/currency3.9da353e3.png";